@import "src/style/lib";

.product-well {
  .cockpit-herowell-content .cockpit-herowell-well {
    @include media-breakpoint-up("lg") {
      padding: 4rem 4rem 4rem 4rem;
      width: 50%;
    }

    @include media-breakpoint-between("sm", "lg") {
      padding: 4rem 2rem 4rem 2rem;
      width: 66.666%;
    }

    @include media-breakpoint-down("sm") {
      padding: 4rem 2rem;
      width: 90%;
    }

    @media print {
      width: 100%;
    }
  }

  .tagline {
    line-height: 1.25;
    margin-top: 0.2rem;
    margin-bottom: 0.4rem;

    .spec-icon {
      margin-right: 0.3em;
    }
  }
  .article-number {
    font-size: 0.8rem;
    color: $bjelin-grey;
  }

  .prices {
    margin: 1em 0;

    .big-price {
      font-size: 1.5rem;
      font-weight: $headings-font-weight;
    }

    .previous-unit-price {
      display: inline;
      margin-left: 20px;
      text-decoration: line-through;
    }

    .price-info {
      font-size: 0.8rem;
      line-height: 24px;
    }
  }
}
